import { toArray } from "lodash-es";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useGamesFetch = () => {
  return useSelector(({ games }) => games.gamesFetch);
};

export const useGameRun = () => {
  return useSelector(({ games }) => games.gameRun);
};

export const useGames = () => {
  return useSelector(({ games }) => games.games);
};

export const useGamesState = () => {
  return useSelector(({ games }) => games);
};

export const useComputedGames = () => {
  return useSelector(({ games }) => toArray(games.computedGames));
};

export const useComputedFavoriteGames = () => {
  return useSelector(({ games }) => toArray(games.computedFavoriteGames));
};

export const useGameSession = () => {
  return useSelector(({ games }) => games.gameSession);
};

export const useGameErrorStatus = () => {
  return useSelector(({ games }) => games.error);
};

export const useIsFavoriteFilterActive = () => {
  return useSelector(({ games }) => games.isFavoriteFilter);
};

export const useFavoriteGamesCount = () => {
  return useSelector(({ games }) => games.countOfFavoriteGames);
};

const BRANDS_3_2 = new Set(["novoline", "amatic"]);
const BRANDS_16_9 = new Set([
  "amaticOriginal",
  "apolloGames",
  "BettingSoftware",
  "booongo",
  "greentube",
  "InBet",
  "kajot",
  "konami",
  "mascot",
  "microgamingFlash",
  "microgamingHtml",
  "netEntHtml",
  "netEntTouch",
  "ocb_poker",
  "OriginalSpirit",
  "playson",
  "playTechOriginal",
  "qsOriginal",
  "wazdan",
]);
const GAMES_3_2 = new Set([]);
const GAMES_16_9 = new Set([
  "king_of_slots",
  "hit_2_split",
  "bob_epic_viking_quest",
]);

export const useAspectRatio = (brand, game) => {
  return useMemo(() => {
    if (brand === undefined || game === undefined) {
      return 4 / 3;
    }

    if (BRANDS_16_9.has(brand.string_id) || GAMES_16_9.has(game.string_id)) {
      return 16 / 9;
    }
    if (BRANDS_3_2.has(brand.string_id) || GAMES_3_2.has(game.string_id)) {
      return 3 / 2;
    }

    return 4 / 3;
  }, [brand, game]);
};
